export default __webpack_public_path__ + "static/media/logo.41d55113.svg";